import React from 'react';
import t from 'prop-types';

var CajaLateral = function CajaLateral(_ref) {
  var id = _ref.id,
      abierta = _ref.abierta,
      children = _ref.children;
  return React.createElement('div', {
    id: id,
    className: "cajaLateral" + (abierta ? " abierta" : " cerrada")
  }, children, ' ');
};

CajaLateral.propTypes = process.env.NODE_ENV !== "production" ? {
  id: t.string,
  abierta: t.bool,
  children: t.any
} : {};
export default CajaLateral;